<template>
    <div v-if="bBearing">
        <div class="bearing">
            <div class="bearing_tips">
                <div class="cha" @click.stop="chaNoOpen">
                    <img src="@/assets/images/antV2/icon_close.png" alt="" />
                </div>
                <div class="dearing_title">朝向设置</div>
                <div class="bearing_list">
                    <div
                        :class="item.open ? 'onOpenClick' : 'openClick'"
                        @click="getSumClick(item, index)"
                        v-for="(item, index) in arrFw"
                        :key="index"
                    >
                        {{ item.value }}
                    </div>
                </div>
                <!-- <div class="btn_sumbit" @click.stop="btnSumbit">确认</div> -->
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        arrFw: { 
            type: Array,
            default: [],
        },
        bBearing: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {};
    },
    methods: {
        getSumClick(item, nIndex) {
            let that = this;
            that.$emit("btnSumbit", item);
            that.$emit("update:bBearing", false);
            // this.arrFw.forEach((it, index) => {
            //   if (index == nIndex) {
            //     it.open = !it.open;
            //   } else {
            //     it.open = false;
            //   }
            // });
        },
        chaNoOpen() {
            let that = this;
            that.$emit("update:bBearing", false);
            this.arrFw.forEach((it) => {
                it.open = false;
            });
        },
        btnSumbit() {
            let that = this;
            that.arrFw.forEach((it) => {
                if (it.open == true) {
                    that.$emit("btnSumbit", it);
                    that.$emit("update:bBearing", false);
                }
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.bearing {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    background: rgba(0, 0, 0, 0.74);
    display: flex;
    align-items: center;
    justify-content: center;

    .bearing_tips {
        width: 650px;
        background: #fff;
        position: relative;
        border-radius: 20px;
        padding-bottom: 30px;
        box-sizing: border-box;

        .cha {
            position: absolute;
            top: -21px;
            right: -21px;
            width: 42px;
            height: 42px;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .dearing_title {
            padding: 40px 0;
            box-sizing: border-box;
            text-align: center;
            font-size: 30px;
            color: #2c368f;
        }

        .bearing_list {
            width: 100%;
            padding: 0 10px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            justify-content: space-between;

            .onOpenClick {
                width: 30%;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #fff;
                height: 80px;
                font-size: 30px;
                background: #2c368f;
                border-radius: 40px;
                margin-bottom: 30px;
            }

            .openClick {
                width: 30%;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #2c368f;
                height: 80px;
                font-size: 30px;
                background: #fff;
                border: 2px solid #2c368f;
                border-radius: 40px;
                margin-bottom: 30px;
            }
        }

        .btn_sumbit {
            width: 60%;
            height: 100px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            height: 80px;
            font-size: 40px;
            margin-top: 30px;
            // border: 2px solid #2c368f;
            background: #2c368f;
            border-radius: 50px;
            margin: 0 auto;
        }
    }
}
</style>